import { createReducer, on } from '@ngrx/store'
import { LpisUserSubjectSearchActions } from './action-types'
import { PerfectScrollbarActions } from '../../../../shared/ui/perfect-scrollbar/state/actions-type'
import { StoreKeysEnum } from '../../../../store/store-keys'
import cloneDeep from 'lodash/cloneDeep'

const INIT_STATE: ILpisUserSubjectSearchState = {
    filterCriteria: {
        offset: 0,
        limit: 5,
        searchText: '',
        exceptLpisIds: [],
    },
    itemCollection: null,
    lpisId: 0,
}

export const lpisUserSubjectSearchReducer = createReducer(
    INIT_STATE,
    // =======================
    //  NECESSARY REDUCER TO WORK WITH PERFECT SCROLLBAR
    //  CANT BE MOVED TO EFFECT SINCE IT NEEDS TO RUN AT FIRST BEFORE OTHER EFFECTS
    // =======================
    on(PerfectScrollbarActions.updateOriginSearchText, (state, { key, fragment }): ILpisUserSubjectSearchState =>
        key === StoreKeysEnum.LpisUserSubjectSearchComponent ? {
            ...state,
            filterCriteria: { ...state.filterCriteria, ...fragment },
        } : state,
    ),
    on(PerfectScrollbarActions.updateOriginFilterCriteria, (state, props): ILpisUserSubjectSearchState =>
        props.key === StoreKeysEnum.LpisUserSubjectSearchComponent ?
            {...state, filterCriteria: { ...state.filterCriteria, ...props.fragment }} : state
    ),
    // !==
    on(LpisUserSubjectSearchActions.setItemCollection, (state, { itemCollection }): ILpisUserSubjectSearchState =>
        ({ ...state, itemCollection }),
    ),
    on(LpisUserSubjectSearchActions.setLpisId, (state, { lpisId }): ILpisUserSubjectSearchState =>
        ({ ...state, lpisId }),
    ),
    on(LpisUserSubjectSearchActions.setFilterCriteria, (state, { filterCriteria }): ILpisUserSubjectSearchState =>
        ({ ...state, filterCriteria }),
    ),
    on(LpisUserSubjectSearchActions.updateFilterCriteria, (state, props): ILpisUserSubjectSearchState => {
        return { ...state, filterCriteria: { ...state.filterCriteria, ...props.criteriaFragment } }
    }),
    on(LpisUserSubjectSearchActions.resetState, (): ILpisUserSubjectSearchState => INIT_STATE),
    on(LpisUserSubjectSearchActions.resetFilterCriteria, (state): ILpisUserSubjectSearchState => {
        const newState = cloneDeep(state)
        newState.filterCriteria = INIT_STATE.filterCriteria
        return newState
    }),
    on(LpisUserSubjectSearchActions.resetItemCollection, (state): ILpisUserSubjectSearchState => {
        const newState = cloneDeep(state)
        newState.itemCollection = INIT_STATE.itemCollection
        return newState
    }),
    on(LpisUserSubjectSearchActions.resetLpisId, (state): ILpisUserSubjectSearchState => {
        return { ...state, lpisId: INIT_STATE.lpisId }
    }),
)

export interface ILpisUserSubjectSearchState {
    filterCriteria: ILpisUserSubjectSearchFilterCriteria;
    itemCollection: any[];
    lpisId: number;
}

export interface ILpisUserSubjectSearchFilterCriteria {
    offset: number;
    limit: number;
    searchText: string;
    exceptLpisIds: number[];
}